<template>
  <div class="layout">
    <Aicons></Aicons>
    <Amain></Amain>
  </div>
</template>

<script>
import Aicons from '@/components/Alayout/Aicon/Aicons'
import Amain from '@/components/Alayout/Amain/Amain'
export default {
  name : 'Alayout',
  components: {
    Aicons,
    Amain
  },
  data(){
    return {
    }
  }
}
</script>

<style scoped>
  .layout{
    height: 100%;
    width: 100%;
    background: rgb(242, 242, 242)
  }
</style>


// WEBPACK FOOTER //
// src/components/Alayout/Alayout.vue